import { Routes, Route } from "react-router-dom";
import LandingPage from '../pages/Landing/LandingPage';
import data from '../data/config.json'

function Landing({user, error}: any) {
  function Invite() {
    window.location.replace(`${data.invite}`);
    return null;
  }
  return (
    <Routes>
      <Route path="/" element={<LandingPage user={user} error={error} />}/>
      <Route path="/invite" element={<Invite />}/>
    </Routes>
  )
}

export default Landing